export const formatReportHtml = (html: string) => {
  if (!html) return "";

  return html
    // Fix escaped HTML tags
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")

    // Remove Quill UI spans
    .replace(/<span class="ql-ui".*?<\/span>/g, "")

    // Convert Quill bullet OL → UL
    .replace(/<ol>/g, '<ul style="padding-left:20px;list-style:disc;">')
    .replace(/<\/ol>/g, "</ul>")

    // Improve list spacing
    .replace(/<li/g, '<li style="margin-bottom:8px;"');
};
